export const OneDayInMs = 1000 * 60 * 60 * 24;
export const OneWeekInMs = OneDayInMs * 7;
export const OneMonthInMs = OneDayInMs * 30;
export const OneYearInMs = OneDayInMs * 365;

export const calculateDaysLeft = (date: Date, now: Date) => {
  return Math.max(0, Math.round((date.getTime() - now.getTime()) / OneDayInMs));
};

export const formatDueOnDate = (date: string) => {
  return new Intl.DateTimeFormat("en-US", { day: "numeric", month: "long" }).format(new Date(date));
};

export const inQuotes = (text: string) => `\u2018${text}\u2019`;
